export const APP_NAME = process.env.REACT_APP_APP_NAME?.trim() || 'EBMS';
